import { Disclosure } from "@headlessui/react";

import * as Track from "@qoohoo/common/utils/analytics/track";
import { button, link, pageview } from "@qoohoo/common/constants/analytics";
import { getMailToLink } from "@qoohoo/common/utils/url";
import useSessionStore from "../../../store/sessionStore";
import FAQ from "../../FAQ";

export default function FAQSection({ channelDetails, isWhiteTheme }) {
  const userData = useSessionStore((state) => state.userData);
  const telegramChannelType = channelDetails.telegram?.telegram_chat_type;

  const faqs = [
    {
      q: "Are your WhatsApp settings correct?",
      a: (
        <div className="leading-loose">
        <div>You will be added only when your WhatsApp settings are set correctly.</div>
        <div>Ensure your settings are set to "Anyone can add".</div>
        <div>How to confirm your settings -</div>
        <ul className="list-disc ml-4">
          <li><strong>Android</strong>: Tap More options &gt; Settings &gt; Account &gt; Privacy &gt; Groups.</li>
          <li><strong>iPhone</strong>: Tap Settings &gt; Privacy &gt; Groups.</li>
        </ul>
        <div>Once your settings are correct, click again on your unique invite.</div>
        </div>
        ),
    },
    {
      q: "How much time it takes to add in group?",
      a: (
        <div>
          <div>
          You will be added in the WhatsApp group within a few minutes after clicking on your invite link. However in some cases, it can take upto 2 hours.
          </div>
          <br/>
          <div>
          Please ensure, you're clicking on your invite link from your registered mobile number only.
          </div>
        </div>
      ),
    },
  ];

  const mailSubject = `Query regarding telegram payment`;
  const mailBody = `Hi qoohoo team,
Please look into the issue regarding Telegram ${telegramChannelType}.

What is your query? Write below:

From: 
Name: ${userData.name || ""}
Username: ${userData.username || ""} 
Phone: ${userData.mobile || ""}
Telegram ${telegramChannelType}: ${channelDetails.name}
Page link: ${channelDetails.short_url_flutter}
`;

  const mailToLink = getMailToLink("support@qoohoo.in", mailSubject, mailBody);

  const trackingDetails = {
    current_screen: pageview.channel_details,
    is_whatsapp: true,
  };

  return (
    <section className=" px-5 pt-14 pb-24 sm:pt-24 sm:pb-40 sm:px-20 font-nunito">
      <h2 className="w-full text-2xl font-bold text-center sm:text-4xl md:text-5xl font-inter leading-[140%] dark:text-[#16191B]">
        FAQs
      </h2>
      <div className="max-w-[630px] mx-auto text-[#DBDBDB] mt-14 space-y-6 w-full md:flex md:flex-col items-center justify-center">
        <FAQ
          faqs={faqs}
          {...trackingDetails}
          defaultOpen={true}
          fullWidth={true}
          isWhiteTheme={isWhiteTheme}
        />
      </div>
      <p className="max-w-[582px] mt-12 mx-auto text-center dark:text-[#16191B]">
        If you need any help, please write to us at{" "}
        <a
          href={mailToLink}
          className="underline"
          onClick={() => {
            Track.linkClick(link.support, {
              current_screen: pageview.channel_details,
              is_telegram: true,
              url: mailToLink,
            });
          }}
        >
          support@qoohoo.in
        </a>
      </p>
    </section>
  );
}
